<template>
  <el-container class="print-rules">
    <el-aside width="220px">
      <div class="title">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="small"
          @click="addGroup"
        >
          新建规则分类
        </el-button>
      </div>

      <div v-loading="groupLoding" class="group">
        <div
          v-for="item in groupList"
          :key="item.id"
          class="item"
          :class="{ active: item.isActive }"
          @click="selectChange(item)"
        >
          <div class="name" :title="item.areaName">{{ item.areaName }}</div>
          <div class="action">
            <i class="el-icon-edit-outline" @click="editGroup(item)"></i>
            <i class="el-icon-delete" @click="delGroup(item)"></i>
          </div>
        </div>
      </div>
    </el-aside>
    <el-main>
      <div class="top">
        <el-button type="primary" size="small" plain @click="addRule">
          增加规则
        </el-button>
        <el-button
          type="primary"
          size="small"
          plain
          style="margin-left: 30px"
          @click="submit"
        >
          发布设置
        </el-button>
      </div>
      <div v-if="groupList.length" class="content">
        <el-form
          ref="formRef"
          :model="formRule"
          inline
          size="small"
          label-width="50px"
        >
          <el-row :gutter="10">
            <template v-for="(rule, index) in formRule.rules">
              <el-col
                :key="index + 'rule'"
                style="display: flex;"
                :xs="24"
                :sm="24"
                :md="24"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  style="display: flex"
                  :prop="'rules.' + index + '.roleId'"
                  :rules="{
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                  }"
                  :label="`${index + 1}`"
                >
                  <el-select
                    v-model="rule.roleId"
                    clearable
                    filterable
                    allow-create
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in ruleOptions"
                      :key="item.id"
                      :label="item.cnName"
                      :value="item.id"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  :prop="'rules.' + index + '.cutId'"
                  :rules="{
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                  }"
                >
                  <div class="split-del">
                    <el-select v-model="rule.cutId" clearable filterable>
                      <el-option
                        v-for="item in splitOptions"
                        :key="item.id"
                        :label="item.cnName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>

                    <i
                      v-if="formRule && formRule.rules.length > 1"
                      class="el-icon-delete"
                      @click="delRule(index)"
                    ></i>
                  </div>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>
      </div>

      <div v-if="groupList.length" class="bottom">
        <el-button type="primary" size="small" @click="handleRulePreview">
          规则预览
        </el-button>
        <el-input
          v-model="rulesPreview"
          type="textarea"
          maxlength="30"
          show-word-limit
          readonly
        >
        </el-input>
      </div>

      <el-dialog
        v-dialogDrag
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="dialogTitle"
        width="500px"
      >
        <div class="areaName">
          <el-form ref="areaForm" :model="areaForm" label-position="top" label-width="110px" :rules="areaRules" size="small">
            <el-form-item label="分类名称:" prop="areaName">
              <el-input ref="areaName" v-model.trim="areaForm.areaName" placeholder="请输入分类名称" size="small" clearable maxlength="25" show-word-limit />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="visible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="saveGroup">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";

import printRulesService from "@/CommonDP/service/printRules-service";
export default {
  name: "PrintRules",
  data() {
    return {
      groupLoding: false,
      visible: false,
      ruleNum: 1,
      ruleOptions: [],
      splitOptions: [],
      formRule: {
        rules: [{ roleId: "", cutId: "" }]
      },
      rulesPreview: "",
      currentGropup: null,
      groupList: [],
      areaForm: {
        areaName: ''
      },
      areaRules: {
        areaName: [{ required: true, message: '请输入分类名称', trigger: "blur" }]
      },
      dialogTitle: '新增分类'
    };
  },

  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {
    this.fetchGroupList();
    this.fetchRuleDic();
    this.fetchSplitDic();
  },
  methods: {
    addRule() {
      const { rules } = this.formRule;
      if (rules.length < 10) {
        this.formRule.rules.push({ roleId: "", cutId: "" });
      } else {
        this.$message.warning("最多只能添加10条规则");
      }
    },
    submit() {
      this.$refs["formRef"].validate(async (valid) => {
        if (valid) {
          const { rules } = this.formRule;
          const { enterpriseId } = this;
          const { id: areaId, areaName } = this.currentGropup;
          const params = {
            areaId,
            areaName,
            enterpriseId,
            roleAndCutList: rules
          };
          await printRulesService.addRule(params);
          this.$message.success("规则创建成功");
        }
      });
    },

    delRule(index) {
      this.formRule.rules.splice(index, 1);
    },

    handleRulePreview() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          const { ruleOptions = [], splitOptions = [] } = this;
          const { rules = [] } = this.formRule;
          let rule_name = "";

          rules.forEach(({ roleId, cutId }) => {
            const role = ruleOptions.find((o) => o.id === roleId);
            const cult = splitOptions.find((o) => o.id === cutId);
            if (role) {
              rule_name += (role.cnName !== '无' ? role.cnName : '') + (cult.cnName !== '无' ? cult.cnName : '');
            } else {
              rule_name += (roleId !== '无' ? roleId : '') + (cult.cnName !== '无' ? cult.cnName : '');
            }
          });

          this.rulesPreview = rule_name;
        }
      });
    },

    async fetchGroupList() {
      this.groupLoding = true;

      const { data } = await printRulesService.queryGroupList(this.enterpriseId);

      this.groupList = data || [];

      if (data && data.length) {
        this.selectChange(data[0]);
      }

      this.groupLoding = false;
    },

    selectChange(item) {
      this.currentGropup = item;
      this.rulesPreview = "";

      this.groupList = this.groupList.map((g) => {
        if (g.id === item.id) {
          return {
            ...g,
            isActive: true
          };
        }

        return {
          ...g,
          isActive: false
        };
      });

      this.fetchRoleList();
    },

    async fetchRoleList() {
      const { id } = this.currentGropup;

      const {
        data: { roleAndCutList = [] }
      } = await printRulesService.queryRoleList(id);

      if (roleAndCutList && roleAndCutList.length) {
        this.formRule.rules = roleAndCutList;
      } else {
        this.formRule.rules = [{ roleId: "", cutId: "" }];
      }
    },

    addGroup() {
      this.areaForm.areaName = "";
      this.currentGropup = null;
      this.visible = true;
      this.dialogTitle = '新增分类';
      this.$nextTick(() => {
        this.$refs.areaName.focus();
        this.$refs.areaForm.clearValidate();
      });
    },

    editGroup(group) {
      this.visible = true;
      this.dialogTitle = '编辑分类';
      this.$nextTick(() => {
        this.$refs.areaForm.clearValidate();
      });
      this.currentGropup = group;
      this.areaForm.areaName = group.areaName;
    },

    async delGroup({ id }) {
      await this.$confirm("确认要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async () => {
        await printRulesService.delGroup(id);
        this.$message.success("删除成功");
        this.fetchGroupList();
      })
        .catch((res) => {
          console.log(res);
        });
    },

    async saveGroup() {
      this.$refs.areaForm.validate(async (valid) => {
        if (valid) {
          const { areaName } = this.areaForm;
          const { id } = this.currentGropup || {};
          const { result } = id
            ? await printRulesService.updateGroup(areaName, id, this.enterpriseId)
            : await printRulesService.addGroup(areaName, this.enterpriseId);
          if (result === "0") {
            this.fetchGroupList();
            this.visible = false;
            this.$message.success("保存成功");
          }
        } else {
          return false;
        }
      });
    },

    async fetchRuleDic() {
      const { data } = await printRulesService.queryRuleDic(this.enterpriseId);

      this.ruleOptions = (data || []).map((item) => {
        if (item.cnName === "固定值") {
          return {
            ...item,
            cnName: "固定值（请手动输入）",
            disabled: true
          };
        }
        return item;
      });
    },

    async fetchSplitDic() {
      const data = await printRulesService.querySplitDic();

      this.splitOptions = data || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.print-rules {
  height: 100%;
  
  .el-aside {
    overflow: hidden;
    margin-right: var(--middle-space);
    background: #fff;
    display: flex;
    flex-direction: column;

    .title {
      text-align: center;
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid #ebefff;
    }

    .group {
      overflow: auto;
      height: 1px;
      flex: 1 0 1px;
      .item {
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ebefff;
        &:hover {
          background: rgba(85, 132, 255, 0.1);
          .action {
            visibility: visible;
          }
        }
        &.active {
          background: rgba(85, 132, 255, 0.2);
        }

        .name {
          display: inline-block;
          width: 135px;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .action {
          font-size: 15px;
          visibility: hidden;

          float: right;
          i {
            cursor: pointer;
            &:last-of-type {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }

  .el-main {
    background: #fff;
    padding: 0;
    .top {
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid #ebefff;
    }

    .content {
      padding: var(--big-space) var(--big-space) 0;
      .rule-group {
        display: inline-block;
        padding: 15px;
      }

      .split-del {
        display: flex;
        align-items: center;

        .el-icon-delete {
          margin-left: 15px;
          color: #f00;
          cursor: pointer;
          font-size: 16px;
        }
      }
    }

    .bottom {
      padding: var(--middle-space) var(--big-space);
      .el-button{
        margin: var(--middle-space) 0;
      }
    }
  }
}

::v-deep .el-form-item__error{
  padding-top: 0 !important;
}
</style>
